/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
import { Box } from '@material-ui/core';

import styles from './styles';

import PageContainer from 'components/PageContainer';
import Title from 'components/Title';
import HorizontalRule from 'components/HorizontalRule';

import useTranslate, {
  useMarkdownTranslate,
} from 'hooks/useTranslate/useTranslate';
import { conformToMask, decimalMoneyMask } from 'utils/masks';

import BreadIcon from '../../BreadIcon';
import ActionButtonsContainer from 'components/ActionButtonsContainer';
import Button from 'components/Button';
import BackToPrevious from 'components/unified/BackToPrevious';

interface PropTypes {
  capacityValue: number;
  nextPath: () => void;
}

const CheckoutSplitPayLearnMoreView: React.FC<PropTypes> = props => {
  const { capacityValue, nextPath } = props;
  const t = useTranslate();
  const tMd = useMarkdownTranslate();

  return (
    <PageContainer>
      <Box mb={2}>
        <Title css={styles.pageTitleText}>
          <BreadIcon
            logo={t('unified.checkoutOffer.splitPayLearnMore.breadLogo')}
            id={'splitpayBreadLogo'}
          />
          {tMd('unified.checkoutOffer.splitPayLearnMore.title')}
        </Title>
      </Box>

      <Box mb={3} css={styles.subtitleText}>
        {tMd('unified.checkoutOffer.splitPayLearnMore.subtitle')}
      </Box>

      <div css={styles.hrContainer}>
        <HorizontalRule />
      </div>

      <Box mb={4} css={styles.bodyContainer}>
        {tMd('unified.checkoutOffer.splitPayLearnMore.body', {
          amount: conformToMask(capacityValue.toFixed(2), decimalMoneyMask),
        })}
      </Box>

      <Box mb={4} css={styles.bodyContainer}>
        <ActionButtonsContainer>
          <Button mobileFullWidth={true} onClick={nextPath}>
            {tMd('unified.offer.paymentOption.splitPay.continue')}
          </Button>
          <BackToPrevious tMdKey="unified.checkoutOffer.splitPayLearnMore.BackToPrevious" />
        </ActionButtonsContainer>
      </Box>
    </PageContainer>
  );
};

export default CheckoutSplitPayLearnMoreView;
